import React from 'react';
import { connect } from 'react-redux';

import { StoreT } from '@global/types.ts';

import ExecutorsHeaderI from './types.ts';

import renderCompanies from './renders/renderCompanies.tsx';
import renderContent from './renders/renderContent.tsx';
import renderInstruction from './renders/renderInstruction.tsx';
import bubbles from './static/bubbles.ts';
import companies from './static/companies.ts';

class ExecutorsHeader
    extends React.Component<ExecutorsHeaderI['props'], ExecutorsHeaderI['state']>
    implements ExecutorsHeaderI
{
    parent: ExecutorsHeaderI['parent'];

    constructor(props: ExecutorsHeaderI['props']) {
        super(props);
        this.state = {};

        this.parent = React.createRef();
    }

    companies = companies;
    bubbles = bubbles;
    joinLink = `${process.env.REACT_APP_APP_DOMEN}/join/livecargo-smz`;

    renderContent = renderContent;
    renderCompanies = renderCompanies;
    renderInstruction = renderInstruction;

    render() {
        return (
            <header className="publicExecutorsHeader">
                <div className="publicExecutorsHeader__inner">
                    {this.renderContent()}
                    {this.renderCompanies()}
                    {this.renderInstruction()}
                </div>
            </header>
        );
    }
}

function mapStateToProps(state: StoreT<'crm'>) {
    return {
        device: state.device,
    };
}

export default connect(mapStateToProps)(ExecutorsHeader);
